export default __webpack_public_path__ + "static/media/thai.2e54d186.svg";